import { createOnboarding } from '@biscuits/client';

export const firstTimeOnboarding = createOnboarding('firstTime', ['welcome']);
